import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  badgeBtn: {
    borderRadius: "12.5px",
    display: "inline-flex",
    border: "none",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.2px",
    lineHeight: "12px",
    textAlign: "center",
    textTransform: "uppercase",
    outline: "none",
    alignItems: "center",
  },
  minimizeHeight: {
    padding: theme.spacing(0.2, 1.5),
  },
  orignalHeight: {
    padding: theme.spacing(0.75, 1.5),
  },
  badgeBtnPrimary: {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
  badgeBtnPrimaryHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 1),
      color: theme.palette.background.default,
      "& .MuiCircularProgress-root": {
        color: theme.palette.background.default,
      },
    },
  },
  badgeBtnSecondary: {
    color: theme.custom.color.apple,
    backgroundColor: alpha(theme.custom.color.apple, 0.12),
  },
  badgeBtnSecondaryHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: alpha(theme.custom.color.apple, 1),
      color: theme.palette.background.default,
      "& .MuiCircularProgress-root": {
        color: theme.palette.background.default,
      },
    },
  },
  badgeBtnTertiary: {
    color: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.12),
  },
  badgeBtnTertiaryHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: alpha(theme.palette.error.main, 1),
      color: theme.palette.background.default,
      "& .MuiCircularProgress-root": {
        color: theme.palette.background.default,
      },
    },
  },
  badgeBtnQuaternary: {
    color: theme.custom.color.mortar,
    backgroundColor: alpha(theme.custom.color.silver, 0.12),
  },
  badgeBtnQuaternaryHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: alpha(theme.custom.color.silver, 1),
      color: theme.palette.background.default,
      "& .MuiCircularProgress-root": {
        color: theme.palette.background.default,
      },
    },
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(6, 4, 3, 4),
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    borderRadius: "33px",
    outline: "none",
    border: "none",
    textAlign: "center",
  },
  modalSmall: {
    maxWidth: "300px",
  },
  modalMedium: {
    maxWidth: "600px",
  },
  modalLarge: {
    maxWidth: "1024px",
  },
  outlined: {
    backgroundColor: theme.palette.background.default,
    border: "1px solid " + alpha(theme.palette.primary.main, 0.12),
  },
}));
